import { IRichRun } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'

export const CLAMP_LINES = 5

// Fallback only — used when the box could not be measured (jsdom, a browser
// without the APIs, a render where the node is gone). Roughly the character
// budget of CLAMP_LINES at the narrowest column the web dialog produces, so a
// declaration past it is long enough that offering the control is right.
export const LONG_DECLARATION_CHARS = 280

export const runsToText = (runs: IRichRun[] = []): string =>
  runs.map((run) => run.text || '').join('')

// measured === null means "not measured": fall back to the length so a failed
// measurement can never hide the ingredient list. Above the web breakpoint the
// "i" button is not rendered, so this control is the only way into the full
// text — silence here would make legally relevant information unreachable.
export const shouldOfferExpand = ({
  measured,
  text,
}: {
  measured: boolean | null
  text: string
}): boolean =>
  measured === null ? text.length > LONG_DECLARATION_CHARS : measured
